import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as Yup from 'yup';
import { deleteLicense, deleteLinkedLicense, deleteLicenseType } from '../../services/service';
import CircularProgress from '@mui/material/CircularProgress'
import './ListPageStyles.css'
import Typography from '@mui/material/Typography'


export default function DeleteLicense({ licenseData, openModal, setOpenModal, onLicenseChanged, tableIndex }) {
    const [loading, setLoading] = useState(false);
    const deleteAndCloseLicenseModal = () => {
        setLoading(true)
        console.log(tableIndex)
        licenseData.map(item =>
            tableIndex === 0 ?
                deleteLicense(item.id).then(() => {
                    setOpenModal(false)
                    onLicenseChanged()
                }).finally(() => {
                    setLoading(false)
                })
                : tableIndex === 1
                    ? deleteLinkedLicense(item.id).then(() => {
                        setOpenModal(false)
                        onLicenseChanged()
                    }).finally(() => {
                        setLoading(false)
                    })
                    : deleteLicenseType(item.id).then(() => {
                        setOpenModal(false)
                        onLicenseChanged()
                    }).finally(() => {
                        setLoading(false)
                    })
        )
    }

    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <div>
            <Dialog
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogContent style={{ padding: '1rem 1rem' }}>
                    <DialogActions>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {licenseData.length > 1
                                ? <span>Tem certeza que deseja apagar as {licenseData.length} licenças selecionadas? </span>
                                : <span>Tem certeza que deseja apagar a licença? </span>
                            }
                        </Typography>
                    </DialogActions>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            style={{ right: '1.5rem' }}>
                            Fechar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => deleteAndCloseLicenseModal()}
                            style={{ right: '1rem' }}>
                            {loading ? <CircularProgress /> : 'Deletar'}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    );
}
